import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María L.',
  age: 34,
  city: 'Buenos Aires',
  text: 'Mi hijo de 4 años no quería ni correr en la plaza. Después de seguir las rutinas por 3 semanas, ya juega con otros nenes sin miedo. Lloré de alegría.'
}, {
  name: 'Gonzalo R.',
  age: 38,
  city: 'Córdoba',
  text: 'Como papá primerizo no tenía idea de qué era normal y qué no. Esta guía me dio la tranquilidad que necesitaba. Muy clara y práctica.'
}, {
  name: 'Luciana M.',
  age: 29,
  city: 'Rosario',
  text: 'Probé mil videos de YouTube y nada servía. Esto es diferente porque tiene un orden lógico. Mi nena mejoró mucho la coordinación.'
}, {
  name: 'Sebastián P.',
  age: 41,
  city: 'Mendoza',
  text: 'Mi hijo tiene 5 años y le costaba mucho el equilibrio. Con los ejercicios de la guía, en un mes ya anda en bici sin rueditas. Increíble.'
}, {
  name: 'Carolina D.',
  age: 33,
  city: 'La Plata',
  text: 'Lo mejor es que son actividades simples que hacemos en casa en 15 minutos. Mi hijo lo ve como un juego y yo veo los resultados.'
}];
export const TestimonialsSection = () => {
  return <section className="py-12" data-id="element-167">
      <h2 className="text-3xl font-black text-center text-[#1B3A5C] mb-10" data-id="element-168">
        Lo que dicen otros padres en Argentina
      </h2>

      <div className="space-y-6" data-id="element-169">
        {testimonials.map((t, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100" data-id="element-170">
            <div className="flex gap-1 mb-3" data-id="element-171">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-172" />)}
            </div>
            <p className="text-gray-700 text-lg italic mb-4" data-id="element-173">"{t.text}"</p>
            <div className="flex items-center gap-3" data-id="element-174">
              <div className="w-10 h-10 bg-[#1B3A5C] rounded-full flex items-center justify-center text-white font-bold" data-id="element-175">
                {t.name.charAt(0)}
              </div>
              <div data-id="element-176">
                <p className="font-bold text-[#1B3A5C]" data-id="element-177">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sm text-gray-500" data-id="element-178">{t.city}</p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
};